import styled, { css } from 'styled-components';

export const Content = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  background-color: #ffffff;
  @media (min-width: 768px) {
    .first-access-top {
      margin-top: 50px;
    }
  }

  h1 {
    width: 100%;
    max-width: 400px;
    font-size: 0.75rem;
    text-align: left;
    color: #7a7a7a;
    margin: 0 0 22px 0;

    @media (max-width: 768px) {
      position: absolute;
      top: -210px;
      left: 0;
      color: rgba(255, 255, 255, 0.95);
      margin-left: -5px;
    }
  }

  .top-overflow {
    overflow-x: hidden;
    overflow-y: auto;
  }
`;

export const Scrollbar = styled.div`
  overflow-y: auto;
  overflow-x: hidden;
  background: transparent;

  display: flex;
  height: 100vh;
  max-height: 100vh;
  min-height: 100vh;

  @media (max-width: 768px) {
    height: auto;
    max-height: unset;
    min-height: unset;
  }
`;

export const Gradient = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: start;
  width: 100%;
  height: 100%;  
  background-image: linear-gradient(to right, #0004FF, #0004FF);
`;

export const ContStepper = styled.div`
  width: 84%;
  margin: 20px 0 0 60px;
  display: flex;
  overflow: hidden;
  @media (max-width: 768px) {
    width: 100%;
    margin: 0 0 0 0;
  }
`;
